import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    page: {
        fontSize: 11
    },
    heading1: {
        fontSize: 18,
        marginBottom: 15
    },
    heading2: {
        fontSize: 14,
        marginBottom: 15
    },
    heading3: {
        fontSize: 12,
        marginBottom: 15
    },
    paragraph: {
        marginBottom: 5
    },
    listItem: {
        flexDirection: 'row',
        marginBottom: 3
    },
    bullet: {
        width: 10
    },
    link: {
        color: 'blue'
    },
    table: {
        borderWidth: 1,
        borderColor: '#2a3740'
    },
    tableRow: {
        flexDirection: 'row'
    },
    tableCell: {
        flex: 1,
        borderWidth: 1,
        borderColor: '#2a3740'
    },
    tableCellHeader: {
        color: '#fff',
        fontWeight: 'bold',
        borderColor: '#2a3740',
        paddingVertical: 2,
        paddingHorizontal: 4
    },
});
